import React from "react";
import PropTypes from "prop-types";
import IconButtonWithTooltip from "./IconButtonWithTooltip";
import SearchInput from "./SearchInput";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const LeftButtonGroup = ({ onAdd, deleteSelected, onSearch }) => {
  return (
    <div className="flex items-center space-x-2">
      <SearchInput onSearch={onSearch} />

      <div className="border-l border-gray-300 h-8 mx-2"></div>

      <IconButtonWithTooltip tooltip="Add" onClick={onAdd}>
        <AddOutlinedIcon />
      </IconButtonWithTooltip>

      <IconButtonWithTooltip tooltip="Delete" onClick={deleteSelected}>
        <DeleteOutlinedIcon />
      </IconButtonWithTooltip>
    </div>
  );
};

LeftButtonGroup.propTypes = {
  onAdd: PropTypes.func,
  deleteSelected: PropTypes.func,
  onSearch: PropTypes.func,
};

export default LeftButtonGroup;
